export default "__VITE_ASSET__CZIDQtPE__"